<template>
  <b-card
    no-body
    class="maximize-create-section fixed-input-wrapper"
    :class="{ __collapse: isCollapse }"
  >
    <span
      v-b-tooltip.hover.left="
        isCollapse
          ? $t('fleetTaskInstant.tooltip.map.close')
          : $t('fleetTaskInstant.tooltip.map.open')
      "
      class="mc-sidebar-toggle mc-section-toggle"
      @click="isCollapse = !isCollapse"
    >
      <i class="mc-fa fas fa-angle-right"></i>
      <i class="mc-fa icon-outline_close"></i>
      <u></u>
    </span>
    <simplebar class="h-100" data-simplebar-auto-hide="false">
      <b-card-body>
        <FormulateForm ref="formRef" v-model="formValues" :errors="formErrors">
          <b-row class="m-0">
            <!-- Informasi Penugasan Section -->
            <b-col cols="12" lg="7" class="__info-section">
              <h5 class="__title">
                {{ $t('fleetTaskInstant.title.assignmentInformation') }}
              </h5>
              <div class="row px-2">
                <template v-for="field in fields">
                  <!-- User Group Input -->
                  <FormulateInput
                    v-if="field.name === 'user_group_id'"
                    v-bind="field"
                    :key="`${field.name}-input`"
                    class="col-12 pt-0 pb-4"
                    validation-behavior="live"
                    :disabled="isLoadingGlobal || isUserGroupDisabled"
                    :fullObject.sync="fullObjects[field.name]"
                    @input="handleUserGroupChange({ key: field.name, value: $event })"
                  />
                  <!-- TODO: Next Development auto fill driver -->
                  <DriverValueHelp
                    v-else-if="field.name === 'driver_id'"
                    :key="`${field.name}-driver-vh`"
                    class="col-6 pt-0"
                    :field="field"
                    :disabled="isLoadingGlobal || isVehicleDriverDisabled"
                    :vehicleFullObj="fullObjects.vehicle_id"
                    :fullObject.sync="fullObjects[field.name]"
                    @input="handleInput({ key: field.name, value: $event })"
                  />
                  <FormulateInput
                    v-else-if="field.name === 'note'"
                    v-bind="field"
                    :key="`${field.name}-textarea`"
                    class="col-12 __textarea-input pt-0"
                    validation-behavior="live"
                    @input="handleInput({ key: field.name, value: $event })"
                  />
                  <FormulateInput
                    v-else-if="field.name === 'vehicle_id'"
                    v-bind="field"
                    :key="`${field.name}-vehicle`"
                    class="col-6 pt-0"
                    validation-behavior="live"
                    :disabled="isLoadingGlobal || isVehicleDriverDisabled"
                    :fullObject.sync="fullObjects[field.name]"
                    @input="handleInput({ key: field.name, value: $event })"
                  />
                  <FormulateInput
                    v-else
                    v-bind="field"
                    :key="`${field.name}-default`"
                    class="col-6 pt-0"
                    validation-behavior="live"
                    :disabled="isLoadingGlobal"
                    :fullObject.sync="fullObjects[field.name]"
                    @input="handleInput({ key: field.name, value: $event })"
                  />
                </template>
              </div>
            </b-col>

            <hr class="__divider-info-section" />

            <!-- Notifikasi Section -->
            <b-col cols="12" lg="5" class="__notification-info-section">
              <h5 class="__title">
                {{ $t('fleetTaskInstant.title.notification') }}
              </h5>

              <FreeWhatsappAlert />

              <FormulateInput
                v-for="field in notificationFields"
                v-bind="field"
                :key="field.key"
                :ref="`${field.name}-ref`"
                class="p-0"
                validation-behavior="live"
                @input="handleInput({ key: field.name, value: $event })"
              >
                <template #prefix>
                  <span class="formulate-input-prefix">+62</span>
                </template>
              </FormulateInput>
            </b-col>
          </b-row>
        </FormulateForm>

        <hr />
        <!-- Tabel Tujuan Section -->
        <PointTable />
      </b-card-body>
    </simplebar>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { Helper } from '@/mixin/helper'

import * as FleetTaskInstant from '@/services/rest-api/lib/fleet-task-instant/fleet-task-instant'
import * as Driver from '@/services/rest-api/lib/fleet-task-instant/driver'
import * as NearestVehicle from '@/services/rest-api/lib/fleet-task-instant/nearest-vehicle'

import FreeWhatsappAlert from '../components/FreeWhatsappAlert'
import PointTable from '../components/PointTable'
import DriverValueHelp from '../wrapper/DriverValueHelp'

import simplebar from 'simplebar-vue'
import cloneDeep from 'lodash/cloneDeep'
import isEqual from 'lodash/isEqual'

import infoFields from '../lib/fields/info-fields'
import notificationFields from '../lib/fields/notification-fields'
import { EventBus } from '../lib/event-bus.js'
import errorInputMsg from '../lib/constants/error-input-msg.js'

export default {
  components: {
    FreeWhatsappAlert,
    PointTable,
    DriverValueHelp,
    simplebar,
  },
  mixins: [Helper, infoFields, notificationFields],
  data() {
    return {
      isInitial: true,
      isCollapse: true,
      isLoading: false,

      formErrors: {},
      initialFormValues: {},
      formValues: {
        user_group_id: null,
        vehicle_id: null,
        driver_id: null,
        phone_number: null,
        note: null,
      },
      fullObjects: {
        user_group_id: {},
        vehicle_id: {},
        driver_id: {},
      },
      oldFullObjects: {},
    }
  },
  computed: {
    ...mapState('fleetTaskInstant', [
      'isLoadingGlobal',
      'showResponse',
      'errorResponse',
      'listPointRes',
    ]),
    isUserGroupDisabled() {
      const status = this.showResponse?.status?.raw_type
      return status && !['TEMPORARY', 'DRAFT', 'SCHEDULED'].includes(status)
    },
    isVehicleDriverDisabled() {
      // If has user group access, disable until user group is selected
      if (this.hasTmsUserGroupAccess) {
        return this.formValues.user_group_id === null
      }
      return false
    },
    // To set column class based on the width of the input section is collapse or not
    layoutConfig() {
      return {
        columnClass: this.isCollapse ? 'col-5' : 'col-3',
      }
    },
    fields() {
      return this.infoFields.map((field) => {
        if (field.name == 'vehicle_id') {
          field.listGetter = this.queryVehicles.get
        } else if (field.name == 'driver_id') {
          field.listGetter = this.queryDrivers.get
        }
        return field
      })
    },
    queryVehicles() {
      return {
        get: async (filter) => {
          const firstPoint = this.listPointRes.points[0]?.address.geolocation.coordinate

          if (firstPoint) {
            filter = {
              ...filter,
              latitude: firstPoint.latitude,
              longitude: firstPoint.longitude,
            }
          }

          // Add user_group_id filter if has access and user group is selected
          if (this.hasTmsUserGroupAccess && this.formValues.user_group_id !== null) {
            filter = {
              ...filter,
              user_group_id: this.formValues.user_group_id,
            }
          }

          const response = await NearestVehicle.get(filter)

          return {
            metadata: {
              total_count: response?.data?.total_count,
              page: 1,
            },
            data: {
              paginated_result: response?.data?.result,
            },
            isPagination: false,
          }
        },
      }
    },
    queryDrivers() {
      return {
        get: async (filter) => {
          // Add user_group_id filter if has access and user group is selected
          if (this.hasTmsUserGroupAccess && this.formValues.user_group_id !== null) {
            filter = {
              ...filter,
              user_group_id: this.formValues.user_group_id,
            }
          }

          return await Driver.get(filter)
        },
      }
    },
  },
  watch: {
    errorResponse(newValue) {
      this.updateFormErrors(newValue)
    },
    '$i18n.locale': function () {
      let errorObj = {}
      if (Object.keys(this.formErrors).includes('phone_number')) {
        errorObj = {
          phone_number: ['is-not-valid-phone-number'],
        }
      }

      if (this.errorResponse && Object.keys(this.errorResponse).length > 0) {
        errorObj = {
          ...errorObj,
          ...this.errorResponse,
        }
      }

      if (Object.keys(errorObj).length > 0) {
        this.updateFormErrors(errorObj)
      }
    },
  },
  created() {
    EventBus.$on('update-form-values', this.setFormValues)
    this.setFormValues()

    if (Object.keys(this.errorResponse).length > 0) {
      this.updateFormErrors(this.errorResponse)
    }

    // set route type to plan
    this.$store.dispatch('fleetTaskInstant/setRouteType', 'plan')
  },
  beforeDestroy() {
    EventBus.$off('update-form-values', this.setFormValues)

    // set route type to default value ('actual')
    this.$store.dispatch('fleetTaskInstant/setRouteType', 'actual')
  },
  methods: {
    /**
     * Set formValues, initialFormValues, and fullObjects from showResponse
     */
    setFormValues(opts = {}) {
      if (Object.keys(this.showResponse).length === 0) return

      Object.keys(this.formValues).forEach((key) => {
        if (opts.updatedKeys?.includes(key)) return

        if (this.formErrors[key]) return

        let replacedKey = key
        if (key.includes('_id')) {
          replacedKey = key.replace('_id', '')
        }

        const value = this.showResponse[replacedKey]

        if (['note', 'phone_number'].includes(key)) {
          const cleanedValue = key === 'phone_number' ? this.cleanPhoneSafe(value) : value
          this.$set(this.formValues, key, cleanedValue)
          this.$set(this.initialFormValues, key, cleanedValue)
          return
        }

        this.$set(this.formValues, key, value?.id || null)
        this.$set(this.initialFormValues, key, value?.id || null)
        this.$set(this.fullObjects, key, value?.id === null ? null : value)
      })

      this.$nextTick(() => {
        this.oldFullObjects = cloneDeep(this.fullObjects)
        this.isInitial = false
      })
    },

    /**
     * Handle User Group change - reset vehicle and driver when user group changes
     */
    handleUserGroupChange({ key, value }) {
      if (this.isInitial) return
      if (this.isLoadingGlobal) return

      // Convert value to number or null
      if (value !== null) {
        value = Number(value) || null
      }

      // Check if user group actually changed
      const hasChanged = this.formValues[key] !== value

      // Set the new user group value
      this.$set(this.formValues, key, value)
      this.$delete(this.formErrors, key)

      // Reset vehicle and driver if user group changed
      if (hasChanged && value !== null) {
        this.$set(this.formValues, 'driver_id', null)
        this.$set(this.fullObjects, 'driver_id', null)
        if (['TEMPORARY', 'DRAFT'].includes(this.showResponse?.status?.raw_type)) {
          this.$set(this.formValues, 'vehicle_id', null)
          this.$set(this.fullObjects, 'vehicle_id', null)
        }
      }

      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.updateDetails({ updatedKeys: [key] })
      }, 500)
    },

    /**
     * For handling input from FormulateInput
     *
     * handleInput attach as event in each FormulateInput because
     * there are certain FormulateInput that need parsing value that
     * can not be handled if the handleInput event attached in FormulateForm
     */
    handleInput: function ({ key, value }) {
      if (this.isInitial) return
      if (!['note', 'phone_number'].includes(key) && this.isLoadingGlobal) return

      if (
        key === 'vehicle_id' &&
        value == null &&
        this.showResponse?.status?.raw_type === 'SCHEDULED'
      ) {
        this.fullObjects = cloneDeep(this.oldFullObjects)
        this.$set(this.formValues, key, this.initialFormValues[key])
        return
      }

      if (key === 'vehicle_id' || key === 'driver_id' || key === 'user_group_id') {
        value = Number(value) || null
      }

      if (['note', 'phone_number'].includes(key) && value === '') {
        value = null
      }

      this.$set(this.formValues, key, value)
      this.$delete(this.formErrors, key)

      let opts = {}
      if (['note', 'phone_number'].includes(key)) {
        opts.updatedKeys = [key]
      }

      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.updateDetails(opts)
      }, 500)
    },
    async updateDetails(opts = {}) {
      this.$store.dispatch('fleetTaskInstant/setIsInitial', false)
      await this.$store.dispatch('fleetTaskInstant/setIsLoadingGlobalDelay', true)
      const data = this.filterUnchangedData(this.formValues, this.initialFormValues)

      // Remove fields with errors from update payload to prevent sending invalid cleared values
      const cleanedData = { ...data[0] }
      Object.keys(this.formErrors).forEach((errorKey) => {
        delete cleanedData[errorKey]
      })

      // Don't send request if payload is empty after removing error fields
      if (Object.keys(cleanedData).length === 0) {
        await this.$store.dispatch('fleetTaskInstant/setIsLoadingGlobalDelay', false)
        return
      }

      const res = await FleetTaskInstant.update(this.$route.params.id, cleanedData)

      if (res.errors) {
        let errorInput = this.$t('global.inputFormatError')

        const firstErrorKey = Object.keys(res.errors)[0]

        if (['vehicle_id', 'driver_id', 'phone_number', 'user_group_id'].includes(firstErrorKey)) {
          const errorKey = `${firstErrorKey}/${res.errors[firstErrorKey][0].replaceAll(' ', '-')}`

          let mapErrInput =
            typeof errorInputMsg[errorKey] === 'function'
              ? errorInputMsg[errorKey]()
              : errorInputMsg[errorKey]

          if (mapErrInput) {
            errorInput = mapErrInput
          }
        }

        this.$set(this.formErrors, firstErrorKey, errorInput)
        await this.$store.dispatch('fleetTaskInstant/setIsLoadingGlobalDelay', false)
        return
      }

      this.$nextTick(async () => {
        await this.$store.dispatch('fleetTaskInstant/setIsLoadingGlobalDelay', false)
      })
      EventBus.$emit('refetch-fleet-task-instant', 'init', 'update-map', {
        updatedKeys: opts.updatedKeys,
      })
    },
    filterUnchangedData(newValue, oldValue) {
      const keys = new Set([...Object.keys(newValue), ...Object.keys(oldValue)])
      const _newValue = {}

      keys.forEach((key) => {
        // if both value is falsy
        if (!oldValue[key] && !newValue[key]) return

        // if oldValue has same value with newValue
        if (oldValue[key] == newValue[key]) return

        // if the oldValue is 'Invalid date' and newValue is null
        if (oldValue[key] === 'Invalid date' && newValue[key] === null) return

        // if it is array
        if (Array.isArray(oldValue[key]) || Array.isArray(newValue[key])) {
          // if oldValue is undefined but the newValue is empty array
          if (!oldValue[key] && newValue[key].length === 0) return

          // matching oldValue and newValue array
          const sortedNewValue = newValue[key]?.length ? newValue[key].sort() : newValue[key]
          const sortedOldValue = oldValue[key] ? oldValue[key].sort() : oldValue[key]

          const isSameArray = isEqual(sortedNewValue, sortedOldValue)

          if (isSameArray) return
        }

        _newValue[key] = newValue[key]
      })

      const entries = Object.entries(_newValue)
      const hasChanged = entries.length > 0 && entries.every((value) => value)
      return [_newValue, hasChanged]
    },
    updateFormErrors(errorObj) {
      const source = errorObj.source
      for (let [key, error] of Object.entries(errorObj)) {
        // Formatting v2 error format
        if (key === 'issues') {
          let key = null
          let errorMsgKey = null

          errorObj.issues.forEach((issue) => {
            if (issue.code === 'FLEET_TASK.FLEET_TASK_INSTANT.AUTO_START_FAILED_REASON') {
              if (issue.message === 'VEHICLE_CONFLICT') {
                key = 'vehicle_id'
                errorMsgKey = `${key}/already-registered`
              } else if (issue.message === 'DRIVER_CONFLICT') {
                key = 'driver_id'
                errorMsgKey = `${key}/already-registered`
              }

              if (key === null) return

              const msg =
                typeof errorInputMsg[errorMsgKey] === 'function'
                  ? errorInputMsg[errorMsgKey]()
                  : errorInputMsg[errorMsgKey]

              this.$set(this.formErrors, key, msg)
            } else if (issue.code === 'FLEET_TASK.FLEET_TASK_INSTANT.USER_GROUP_ID.REQUIRED') {
              this.$set(this.formErrors, 'user_group_id', errorInputMsg['user_group_id/required']())
            } else if (issue.code === 'FLEET_TASK.VEHICLE_GROUP_INVALID') {
              this.$set(this.formValues, 'vehicle_id', null)
              this.$set(this.fullObjects, 'vehicle_id', null)
              this.$set(this.formErrors, 'vehicle_id', errorInputMsg['vehicle_id/required']())
            } else if (issue.code === 'FLEET_TASK.DRIVER_USER_GROUP_INVALID') {
              this.$set(this.formValues, 'driver_id', null)
              this.$set(this.fullObjects, 'driver_id', null)
              this.$set(this.formErrors, 'driver_id', errorInputMsg['driver_id/required']())
            }else if (issue.code === 'FLEET_TASK.VEHICLE_STATUS_INVALID') {
              this.$set(this.formErrors, 'vehicle_id', errorInputMsg['vehicle_id/vehicle status invalid']())
            }
          })

          break
        }

        if (
          ![
            'vehicle_id',
            'driver_user_id',
            'phone_number',
            'vehicle.id',
            'driver.id',
            'user_group_id',
          ].includes(key)
        )
          continue

        let errorMsg = ''
        if (key === 'driver_user_id' || key === 'driver.id') {
          key = 'driver_id'
        } else if (key === 'vehicle.id') {
          key = 'vehicle_id'
        }

        const transitionMap = {
          vehicle_id: 'vehicle_id/vehicleGroupInvalid',
          driver_id: 'driver_id/driverUserGroupInvalid',
        }

        // Error vehicle_id, driver_id, user_group_id
        let errorKey = ''
        if (error[0].includes('already registered')) {
          errorKey = `${key}/already-registered`
        } else if (error[0].includes('value not found') || error[0].includes('NOT_FOUND')) {
          errorKey = `${key}/value-not-found`
        } else if (
          error[0].includes('user group is required') ||
          error[0].includes('vehicle group invalid') ||
          error[0].includes('driver user group invalid')
        ) {
          if (source === 'transition') {
            errorKey = transitionMap[key] || `${key}/required`
          } else {
            errorKey = `${key}/required`
          }
        } else {
          errorKey = `${key}/${error[0]}`
        }

        if (errorInputMsg[errorKey]) {
          errorMsg =
            typeof errorInputMsg[errorKey] === 'function'
              ? errorInputMsg[errorKey]()
              : errorInputMsg[errorKey]
        } else {
          errorMsg = this.$t('global.inputFormatError')
        }

        this.$set(this.formErrors, key, errorMsg)
      }
    },
  },
}
</script>

<style lang="scss">
.maximize-create-section {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 1px solid $mep-primary-100;
  z-index: 114;

  .card-body {
    overflow-y: auto;

    .__info-section {
      padding-left: 0;

      @media (max-width: 991px) {
        padding: 0;
      }
    }

    .mc-input.input-md {
      height: 37px !important;
    }

    .__textarea-input {
      margin-top: 16px;

      .formulate-input-element {
        textarea {
          height: 80px;
          max-height: 80px;
        }
      }
    }

    .__divider-info-section {
      margin-top: 16px;

      @media (min-width: 992px) {
        display: none;
      }
    }

    .__notification-info-section {
      padding-right: 0;

      @media (min-width: 992px) {
        border-left: 1px solid $teal-100;
      }

      @media (max-width: 991px) {
        padding: 0;
        margin: 8px 0;
      }
    }
  }

  .mc-section-toggle {
    position: absolute;
    z-index: 2;
    left: auto;
    right: -1px;
    border-radius: 10px 0 0 10px;
    border: 1px solid $mep-primary-100;
    transition: none;
    .mc-fa {
      -webkit-transform: rotate(180deg);
      transform: rotate(180deg);
    }
  }

  &.__collapse {
    width: 60%;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;

    .mc-section-toggle {
      left: auto;
      right: -32px;
      border-radius: 0 10px 10px 0;
      .mc-fa {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
      }
    }
  }
}
</style>
